module.exports = __webpack_public_path__ + "assets/img/icon-manychat.3b0ce019.png";